import '../styles/dochano.scss'
import { ReactComponent as DochanoLogo } from '../assets/dochanoLogo.svg'
import usePageTitle from '../hooks/usePageTitle';

function Dochano() {
  usePageTitle("Dochano - Don't you know?");

  return (
    <section id="Dochano">
      <div id="Intro">
        <DochanoLogo title="Donchano - Don't you know? logo" />
      </div>

      <p>Pronounced "Don't you know?" as a tribute to my youth when I would respond with this phrase to join my parents converstion surrounding a wide variety of questions. Such as:</p>
      
      <ul>
        <li>Do you know who lives there?</li>
        <li>What time should we show up?</li>
        <li>What is her name again?</li>
        <li>etc...</li>
      </ul>

      <p>So now you know the history surrounding the name of this site.</p>
    </section>
  );
}

export default Dochano;